const fiscalNone = {
  invoiceId: null,
  invoiceNumber: '',
  invoiceType: 'none',
  accessKey: '',
  installmentGroupId: null,
  installmentNumber: 1,
  installmentTotal: 1,
  totalAmount: null,
};

export const accountsReceivable = [
  {
    id: 'ar_001a',
    organizationId: 'org_3la_labs',
    clientId: 'cli_xpto',
    clientName: 'Empresa XPTO Tecnologia',
    description: 'Implantação módulo financeiro',
    category: 'Serviços',
    issueDate: '20/08/2026',
    dueDate: '05/08/2026',
    amount: 2500,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Recebido',
    notes: '',
    recurring: false,
    invoiceId: 'nf_245',
    invoiceNumber: '000245',
    invoiceType: 'nfse',
    accessKey: '',
    installmentGroupId: 'ig_ar_implant',
    installmentNumber: 1,
    installmentTotal: 2,
    totalAmount: 5000,
  },
  {
    id: 'ar_001',
    organizationId: 'org_3la_labs',
    clientId: 'cli_xpto',
    clientName: 'Empresa XPTO Tecnologia',
    description: 'Implantação módulo financeiro',
    category: 'Serviços',
    issueDate: '20/08/2026',
    dueDate: '05/09/2026',
    amount: 2500,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Pendente',
    notes: '',
    recurring: false,
    invoiceId: 'nf_245',
    invoiceNumber: '000245',
    invoiceType: 'nfse',
    accessKey: '',
    installmentGroupId: 'ig_ar_implant',
    installmentNumber: 2,
    installmentTotal: 2,
    totalAmount: 5000,
  },
  {
    id: 'ar_002',
    organizationId: 'org_3la_labs',
    clientId: 'cli_emsoft',
    clientName: 'Emsoft Solutions',
    description: 'Suporte mensal — setembro',
    category: 'Serviços',
    issueDate: '01/09/2026',
    dueDate: '10/09/2026',
    amount: 1500,
    paymentMethod: 'Boleto',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Agendado',
    notes: '',
    recurring: true,
    ...fiscalNone,
    totalAmount: 1500,
  },
  {
    id: 'ar_003',
    organizationId: 'org_3la_labs',
    clientId: 'cli_emsoft',
    clientName: 'Emsoft Solutions',
    description: 'Desenvolvimento API integração',
    category: 'Serviços',
    issueDate: '25/08/2026',
    dueDate: '15/09/2026',
    amount: 3300,
    paymentMethod: 'Transferência',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Pendente',
    notes: '40 horas',
    recurring: false,
    ...fiscalNone,
    totalAmount: 3300,
  },
  {
    id: 'ar_004',
    organizationId: 'org_3la_labs',
    clientId: 'cli_alpha',
    clientName: 'Studio Alpha Design',
    description: 'Licenças 3LA Manager (anual)',
    category: 'Produtos',
    issueDate: '10/08/2026',
    dueDate: '28/08/2026',
    amount: 1200,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_mp',
    bankAccountName: 'Mercado Pago',
    status: 'Vencido',
    notes: '4 licenças',
    recurring: false,
    invoiceId: 'nf_242',
    invoiceNumber: '000242',
    invoiceType: 'nfse',
    accessKey: '',
    installmentGroupId: null,
    installmentNumber: 1,
    installmentTotal: 1,
    totalAmount: 1200,
  },
  {
    id: 'ar_005',
    organizationId: 'org_3la_labs',
    clientId: 'cli_horizonte',
    clientName: 'Agência Horizonte',
    description: 'Consultoria de processos',
    category: 'Consultoria',
    issueDate: '01/09/2026',
    dueDate: '20/09/2026',
    amount: 5420,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Pendente',
    notes: '',
    recurring: false,
    invoiceId: 'nf_243',
    invoiceNumber: '000243',
    invoiceType: 'nfse',
    accessKey: '',
    installmentGroupId: null,
    installmentNumber: 1,
    installmentTotal: 1,
    totalAmount: 5420,
  },
  {
    id: 'ar_006',
    organizationId: 'org_3la_labs',
    clientId: 'cli_xpto',
    clientName: 'Empresa XPTO Tecnologia',
    description: 'Suporte mensal — agosto',
    category: 'Serviços',
    issueDate: '01/08/2026',
    dueDate: '10/08/2026',
    amount: 1500,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_nubank',
    bankAccountName: 'Nubank PJ',
    status: 'Recebido',
    notes: '',
    recurring: true,
    invoiceId: 'nf_240',
    invoiceNumber: '000240',
    invoiceType: 'nfse',
    accessKey: '',
    installmentGroupId: null,
    installmentNumber: 1,
    installmentTotal: 1,
    totalAmount: 1500,
  },
  {
    id: 'ar_007',
    organizationId: 'org_3la_labs',
    clientId: 'cli_horizonte',
    clientName: 'Agência Horizonte',
    description: 'Treinamento operacional',
    category: 'Consultoria',
    issueDate: '15/07/2026',
    dueDate: '01/08/2026',
    amount: 2500,
    paymentMethod: 'PIX',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Recebido',
    notes: '',
    recurring: false,
    ...fiscalNone,
    totalAmount: 2500,
  },
  {
    id: 'ar_nfe_001',
    organizationId: 'org_3la_labs',
    clientId: 'cli_xpto',
    clientName: 'Empresa XPTO Tecnologia',
    description: 'NFe 003123 — Venda de mercadoria',
    category: 'Produtos',
    issueDate: '01/09/2026',
    dueDate: '15/09/2026',
    amount: 2500,
    paymentMethod: 'Boleto',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Pendente',
    notes: 'Duplicata 001',
    recurring: false,
    invoiceId: 'nfe_3123',
    invoiceNumber: '003123',
    invoiceType: 'nfe',
    accessKey: '35260912345678000190550010000031231000031231',
    installmentGroupId: 'ig_nfe_3123',
    installmentNumber: 1,
    installmentTotal: 2,
    totalAmount: 5000,
  },
  {
    id: 'ar_nfe_002',
    organizationId: 'org_3la_labs',
    clientId: 'cli_xpto',
    clientName: 'Empresa XPTO Tecnologia',
    description: 'NFe 003123 — Venda de mercadoria',
    category: 'Produtos',
    issueDate: '01/09/2026',
    dueDate: '15/10/2026',
    amount: 2500,
    paymentMethod: 'Boleto',
    bankAccountId: 'bank_bb',
    bankAccountName: 'Banco do Brasil',
    status: 'Agendado',
    notes: 'Duplicata 002',
    recurring: false,
    invoiceId: 'nfe_3123',
    invoiceNumber: '003123',
    invoiceType: 'nfe',
    accessKey: '35260912345678000190550010000031231000031231',
    installmentGroupId: 'ig_nfe_3123',
    installmentNumber: 2,
    installmentTotal: 2,
    totalAmount: 5000,
  },
];
